import { Link, useLocation } from '@remix-run/react'
import { cn } from '~/utils/misc.tsx'
import { Spacer } from '~/components/ui/spacer.tsx'

export const AuthLayout = ({
  children,
  className,
  backUrl,
}: {
  children: React.ReactNode
  className?: string
  backUrl?: string
}) => {
  const location = useLocation()

  return (
    <div
      className={cn(
        'relative flex min-h-screen w-full items-center justify-center overflow-hidden',
        className,
      )}
    >
      <div className="relative z-20 flex w-full items-center justify-center">
        <div className="w-full max-w-[800px] pt-6">
          <div className="mx-auto w-full max-w-md">
            <div className="flex flex-col items-center gap-3 [&>*]:w-full [&>*]:px-8">
              <Link to="/" className="inline-flex justify-center text-center">
                <img src="/img/logo-itraack.svg" alt="ITraack logo" />
              </Link>
              <Spacer size="4xs" />
              {children}
              <Link
                to={backUrl ?? '/'}
                className={`mx-auto mt-2 text-center font-semibold text-foreground-muted ${
                  location.pathname.includes('login') ? 'hidden' : ''
                }`}
              >
                Volver a Inicio
              </Link>
              <Spacer size="4xs" />
            </div>
          </div>
        </div>
      </div>
      <img
        src="/img/line-1.svg"
        alt="ITrack line 1"
        className="absolute -left-8 -top-6 w-2/5 max-w-lg"
      />
      <img
        src="/img/line-2.svg"
        alt="ITrack line 2"
        className="absolute -bottom-2 -right-6 w-2/6 max-w-md rotate-90 lg:-right-20 lg:bottom-14"
      />
    </div>
  )
}
